<template>
  <v-card>
    <div class="container-fluid">
      <v-row class="col-12" justify="center">
        <v-col cols="12" class="text-center"><h2>Tisk jídelníčku</h2></v-col>
        <v-col
          cols="6"
        >
          <v-date-picker
            v-model="dateRange"
            range
            locale="cs-cz"
            first-day-of-week="1"
          ></v-date-picker>
        </v-col>
        <v-col
          cols="6"
        >
          <v-text-field
            v-model="datesText"
            label="Datum od - do"
            prepend-icon="mdi-calendar"
            readonly
            outlined
          ></v-text-field>
          <h4>Tisk kolonek</h4>
          <v-checkbox label="Kalorie" v-model="columnSettings.calories"></v-checkbox>
          <v-checkbox label="Alergeny"  v-model="columnSettings.alergens"></v-checkbox>
          <v-checkbox label="Váha" v-model="columnSettings.weight"></v-checkbox>
          <v-checkbox label="Objem" v-model="columnSettings.volume"></v-checkbox>
          <v-checkbox label="Cena" v-model="columnSettings.price"></v-checkbox>
          <v-checkbox label="Rozepsat menu" v-model="columnSettings.expandMenu"></v-checkbox>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn
            tile
            color="primary"
            :disabled="dateRange.length !== 2 || submitWait"
            @click="printDays(false)"
          >
            <v-icon left>
              mdi-printer
            </v-icon>
            Tisk
          </v-btn>
          <v-btn
            class="ml-6"
            tile
            color="primary"
            :disabled="dateRange.length !== 2 || submitWait"
            @click="printDays(true)"
          >
            <v-icon left>
              mdi-magnify
            </v-icon>
            Náhled
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
export default {
  name: 'PrintDietForm',
  props: {
    dietId: {
      type: Number,
      required: true
    },
    timeTypes: {
      type: Array
    }
  },
  data () {
    return {
      dateRange: [],
      submitWait: false,
      columnSettings: {
        calories: false,
        alergens: true,
        weight: false,
        volume: false,
        price: true,
        expandMenu: true
      }
    }
  },
  computed: {
    datesText () {
      // !!this.dateRange should be sorted
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dateRange.sort().join(' – ')
    }
  },
  methods: {
    printDays (lookup) {
      this.submitWait = true
      this.$http.post(`admin/diets/${this.dietId}/days/range`, {
        from: this.dateRange[0],
        to: this.dateRange[1]
      })
        .then(res => {
          const response = this.keysToCamelCase(res.data)
          /*
          * response = {
          *   name: string,
          *   id: number,
          *   dietDays:
          *   [
          *     {
          *     id: number,
          *     date: string,
          *     dietDayItems:
          *       [
          *         {
          *         timeId: number <1-6>,
          *         type: string <'App\Food', 'App\Drink', 'App\Menu'>
          *         eatable:
          *           {
          *           name: string,
          *           calories: number,
          *           price: number,
          *           weight: string        **pouze App\Food a App\Menu,
          *           volume: string        **pouze App\Drink
          *           alergens:
          *             [
          *               {
          *                 name: string
          *               }
          *             ]
          *           }
          *         }
          *       ]
          *     }
          *   ]
          * }
          * */
          const days = response.dietDays
            .sort((a, b) => {
              const dateA = new Date(a.date)
              const dateB = new Date(b.date)
              return dateA.getTime() - dateB.getTime()
            })

          pdfMake.vfs = pdfFonts.pdfMake.vfs
          const docDefinition = {
            pageOrientation: this.getPrintableHeaders().length > 5 ? 'landscape' : 'portrait',
            content: [{
              text: `Jídelníček: ${response.name}`,
              style: 'header'
            }],
            styles: {
              header: {
                fontSize: 15,
                bold: true,
                lineHeight: 0
              },
              new: {
                fontSize: 10,
                italic: true
              }
            }
          }

          if (!days.length) {
            docDefinition.content.push({
              text: 'Pro zadané období nejsou k dispozici žádná data'
            })
          }
          days.forEach(day => {
            const daySection = []
            const meals = [[], [], [], [], [], []].map((time, index) => {
              return day.dietDayItems.filter(item => item.timeId === index + 1)
            })
            const timeNames = this.timeTypes.map(time => time.name)

            // date
            const date = new Date(day.date)
            const tmpLocaleDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
            const localeDayStr = tmpLocaleDayStr[0].toUpperCase() + tmpLocaleDayStr.slice(1)
            const localeDate = date.toLocaleDateString('cs-CZ', { year: 'numeric', month: 'numeric', day: 'numeric' })
            daySection.push({
              text: `${localeDate} ${localeDayStr}`,
              margin: [0, 30, 0, 0],
              bold: true
            })

            // items
            meals.forEach((time, i) => {
              if (time.length) {
                // time type name
                daySection.push({
                  text: timeNames[i],
                  margin: [0, 0, 0, 0]
                })
                const mealTableRows = []
                time.forEach(meal => {
                  if (meal.type === 'App\\Menu') {
                    mealTableRows.push(this.getPrintableColumns(meal))

                    if (this.columnSettings.expandMenu) {
                      meal.eatable.drinks.concat(meal.eatable.foods).forEach(menuItem => {
                        mealTableRows.push(this.getPrintableColumns(menuItem))
                      })
                    }
                  } else {
                    mealTableRows.push(this.getPrintableColumns(meal))
                  }
                })
                daySection.push({
                  layout: 'exampleLayout',
                  style: ['new'],
                  table: {
                    widths: this.getPrintableWidths(),
                    body: [
                      this.getPrintableHeaders(),
                      ...mealTableRows
                    ]
                  }
                })
              }
            })

            docDefinition.content.push(daySection)
            // TODO: vyresit stack
            /* docDefinition.content.push({
              stack: daySection,
              unbreakable: true
            }) */
          })
          pdfMake.tableLayouts = {
            exampleLayout: {
              hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return 0
                }
                return (i === node.table.headerRows) ? 2 : 1
              },
              vLineWidth: function (i) {
                return 0
              },
              hLineColor: function (i) {
                return i === 1 ? 'green' : '#34eb92'
              },
              paddingLeft: function (i) {
                return i === 0 ? 0 : 8
              },
              paddingRight: function (i, node) {
                return (i === node.table.widths.length - 1) ? 0 : 8
              },
              text: function (i, node) {
                return (i === 2)
              }
            }
          }
          lookup === true ? pdfMake.createPdf(docDefinition).open() : pdfMake.createPdf(docDefinition).download(`${response.name}_${this.dateRange[0]}-${this.dateRange[1]}`)
          this.submitWait = false
        })
    },
    getPrintableColumns (item) {
      const meal = item.eatable || item
      const result = [
        item.type === 'App\\Menu' ? 'Menu' : '',
        meal.name
      ]

      if (this.columnSettings.calories) {
        result.push(meal.calories)
      }
      if (this.columnSettings.alergens) {
        const alergensStr = meal.alergens
          .map(alergen => alergen.name)
          .join(', ')
        result.push(alergensStr)
      }
      if (this.columnSettings.weight) {
        if (meal.weight !== undefined) {
          result.push(meal.weight)
        } else {
          result.push('-')
        }
      }
      if (this.columnSettings.volume) {
        if (meal.volume !== undefined) {
          result.push(meal.volume)
        } else {
          result.push('-')
        }
      }
      if (this.columnSettings.price) {
        result.push(meal.price)
      }

      return result
    },
    getPrintableWidths () {
      const result = [40, 100]
      let additionalColumns = 0

      // eslint-disable-next-line no-unused-vars
      for (const [column, value] of Object.entries(this.columnSettings)) {
        if (value) {
          ++additionalColumns
        }
      }
      for (let i = 0; i < additionalColumns; i++) {
        result.push(100)
      }

      return result
    },
    getPrintableHeaders () {
      const result = ['', 'Název']

      if (this.columnSettings.calories) {
        result.push('Kalorie')
      }
      if (this.columnSettings.alergens) {
        result.push('Alergeny')
      }
      if (this.columnSettings.weight) {
        result.push('Váha')
      }
      if (this.columnSettings.volume) {
        result.push('Objem')
      }
      if (this.columnSettings.price) {
        result.push('Cena')
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>
